import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/caret-square-right': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M176 354.9V157.1C176 146.4 189 141 196.5 148.6L294.8 247.5C299.5 252.2 299.5 259.7 294.8 264.4L196.5 363.3C189 371 176 365.6 176 354.9zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/caret-square-right.js
// module id = k0+7
// module chunks = 144